/**
 *
 * # Considerations:
 *
 *  ## Why isn't Amplitude here?
 *  Simple, to prevent excesive tracks traffic to Amplitude (It's really $$$ expensive) and not neccesary.
 *  We can get the sales performance metrics with google analytics or other tools.
 *  Only use Amplitude to understand specific flows, a/b tests or funnels to understand where are we churning.
 *  It's really important no send tracks to Amplitude if you don't have a specific planning for them.
 *
 * ## Google analytics
 * We support Enhanced E-commerce so we track every try to add to cart or product selling to google analytics.
 *
 * ## User activity (Intern equivalent to Amplitude, built with our own hands)
 * This is still tricky and the backend understand it's major impact and how the data should be shaped for it
 * This should replace most Amplitude use in the future. Ask Jonathan Carrasco, he knows how the service works.
 * He built it almost enterily.
 */
import userActivity from "./userActivity";
var TRACKER_NAME = 'crehTracking';
var GOOGLE_ANALYTICS_PROPERTY_ID = 'UA-60829200-1';
var sendPurchaseToUserActivity = function sendPurchaseToUserActivity(product) {
  return userActivity.track(userActivity.EVENTS.CLICK, {
    item_id: product.id,
    item_type: product.type,
    item_name: product.name,
    item_path: window.location.pathname
  });
};
var GoogleAnalytics = {
  addToCart: function addToCart(product) {
    return new Promise(function (resolve) {
      try {
        // @ts-ignore
        if (window && typeof window.ga === 'function' && window.ga.loaded) {
          // Initialize tracking
          // @ts-ignore
          window.ga('create', GOOGLE_ANALYTICS_PROPERTY_ID, {
            name: TRACKER_NAME
          });
          // @ts-ignore
          window.ga("".concat(TRACKER_NAME, ".require"), 'ec');
          // Add product to be tracked
          var productFieldObject = {
            id: product.productId,
            name: product.name,
            category: product.category,
            quantity: 1
          };
          if (process.env.NODE_ENV !== 'production') {}

          // @ts-ignore
          window.ga("".concat(TRACKER_NAME, ".ec:addProduct"), productFieldObject);
          // @ts-ignore
          window.ga("".concat(TRACKER_NAME, ".ec:setAction"), 'add');
          // @ts-ignore
          window.ga("".concat(TRACKER_NAME, ".send"), 'event', 'UX', 'click', 'add to cart', {
            hitCallback: function hitCallback() {
              resolve({
                name: 'Google Analytics',
                success: true
              });
            }
          });
          setTimeout(function () {
            resolve({
              name: 'Google Analytics',
              success: true
            });
          }, 0);
        } else {
          console.error("Google analytics couldn't be loaded");
          resolve({
            name: 'Google Analytics',
            success: false
          });
        }
      } catch (error) {
        resolve({
          name: 'Google Analytics',
          success: false
        });
      }
    });
  }
};

/**
 * Sends tracks to google analytics and user activity
 * @param product
 */
export var trackProduct = function trackProduct(product) {
  var sendToAnalytics = function sendToAnalytics() {
    return GoogleAnalytics.addToCart(product);
  };
  var asyncFunctions = [sendPurchaseToUserActivity(product), sendToAnalytics()];
  return Promise.all(asyncFunctions);
};
var buyProduct = function buyProduct(buyUrl, product) {
  if (product.id !== 0) {
    try {
      if (process.env.NODE_ENV !== 'production') {}

      /** TODO: Any error in this promise.all will be catched at the top try/catch.
        We can improve it later, implementing specific exception handling, but is not neccesary right now.
      */
      trackProduct(product).then(function () {
        window.location.href = buyUrl;
      })["catch"](function (err) {
        console.error('Error while tracking product', err);
        window.location.href = buyUrl;
      });
    } catch (error) {
      // If any track fails we should move on, and don't stop the shopping process
      window.location.href = buyUrl;
    }
  } else {
    window.location.href = buyUrl;
  }
};

// Reexport to maintain compatibility
export { formatProduct } from "./formatProduct";
export default buyProduct;